import {
  Component,
  NgModule,
  Input,
  Output,
  EventEmitter
} from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { PortService } from "../../port/port.service";
import { HttpModule } from "@angular/http";
import { FormsModule, NgForm } from "@angular/forms";
import { Observable, Subject } from "rxjs";
import { Port } from "../../port/model/port";
import { debounceTime, distinctUntilChanged, switchMap } from "rxjs/operators";
import { OffrecommercialeService } from "../offrecommerciale.service";
import { RechercheOffresCommercialesForm } from "../model/form/rechercheOffresCommercialesForm";
import { Pays } from "../../port/model/pays";
import { TypeTransport } from "../model/typeTransport";
import { CompagnieMaritimeLight } from "../model/compagnieMaritimeLight";
import { Manutentionnaire } from "../model/manutentionnaire";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from "@angular/forms";
import { map, startWith } from "rxjs/operators";
import { IFilterAutoComplete } from "../model/IFilterAutoComplete";
import { PortSearchForm } from "../model/form/portSearchForm";
import { TranslateService } from "@ngx-translate/core";
import { OffreLightByTypeTouche } from "../model/offreLightByTypeTouche";
import { RechercheOffresCommercialesFormNom } from "../model/form/rechercheOffreCommercialFormNom";
import { UserInformaions } from "../../common/userinformations";
import { MarkerInfos } from "../../map/markerInfos";
//import { DeviceDetectorService } from "ngx-device-detector";
import { Location } from "../../location";
import { GeocodingService } from "../../geocoding.service";
declare var L: any;

@Component({
  selector: "advance-search",
  templateUrl: "./advancesearch.component.html"
})
export class AdvanceSearchComponent {
  @Input()
  langue: string;

  /*************** Const **************/
  DEFAULT_PORT: string = "Marseille - Fos";
  FORM_DIRECT: string = "DIRECT";
  FORM_TRANSBORDEMENT: string = "TRANSBO";
  BOTH: string = "BOTH";
  FORM_MARSEILLE = "FRMRS";
  FORM_FOS = "FRFOS";
  BTN_DEFAULT = "btn-default";
  BTN_PRIMARY = "btn-primary";
  /* declencher l'appel au parent afin d'afficher les valeurs du résultat de la recherche simple */
  @Output()
  rechercherOffrecommercialeEmitter = new EventEmitter<
    OffreLightByTypeTouche
  >();
  @Output()
  searchNoResultEmitter = new EventEmitter<void>();
  @Output()
  showHidePanelEmitter = new EventEmitter<void>();
  @Output()
  addMarkerEmitter = new EventEmitter<MarkerInfos>();
  @Output()
  searchMapEmitter = new EventEmitter<MarkerInfos>();
  @Output()
  aucunServicePourLePortRechercheEmitter = new EventEmitter<boolean>();
  disabledSearch: boolean = true;
  searcheResult: OffreLightByTypeTouche;
  btnPrimaryOrDefault = this.BTN_DEFAULT;
  /*************** Décartations des observateurs pour l'autocompletion sur les ports ***************/
  portsFrom$: Observable<Port[]>;
  private fromSearchTerms = new Subject<PortSearchForm>();
  fromValue: Port;

  portsTo$: Observable<Port[]>;
  private toSearchTerms = new Subject<PortSearchForm>();
  toValue: Port;
  marseillePort: Port = new Port(
    null,
    this.DEFAULT_PORT,
    null,
    null,
    null,
    null,
    null,
    null,
    null
  );
  /* */

  ports: Port[];
  listpays: Pays[];
  compagnies: CompagnieMaritimeLight[];
  offrescommercieles: OffreLightByTypeTouche;
  portsTouches: Port[];

  /*Formulaire de recherche à envoyer au ws pour récupèrer le résultat de recherche des offres
  commerciales*/
  controlFormPays = new FormControl();
  controlFormTypeTransport = new FormControl();
  controlFormCompagniesMaritimes = new FormControl();
  controlFormManutentionnaire = new FormControl();
  searchFormByIds: RechercheOffresCommercialesForm;
  searchFormModel: RechercheOffresCommercialesFormNom = new RechercheOffresCommercialesFormNom(
    null,
    null,
    null,
    null,
    null,
    null,
    null
  );
  filteredMautentionnaires: Observable<IFilterAutoComplete[]>;
  manuValue: Manutentionnaire;
  filteredCompagnies: Observable<IFilterAutoComplete[]>;
  compagnieValue: CompagnieMaritimeLight;
  filteredTypesTransports: Observable<IFilterAutoComplete[]>;
  typeTranspValue: TypeTransport;
  filteredPays: Observable<IFilterAutoComplete[]>;
  paysValue: Pays;
  /* Champs liés au formulaire de la recherche avancée*/

  isDirect: boolean = true;
  isTransbordement: boolean = true;
  isMarseille: boolean = true;
  isFos: boolean = true;
  isMarseilleImport: boolean = true;
  /* ******* ******* ******** */
  errorMessage: string;
  form_id: String;

  userInformations: UserInformaions;
  LRM;

  //Formulaire de recherche

  constructor(
    private portsService: PortService,
    private offreCommercialeService: OffrecommercialeService,
    private translate: TranslateService,
    private geocoder: GeocodingService
  ) {
    this.getTranslation(this.translate.currentLang);
  }

  getTranslation(langue: string) {
    this.translate.currentLang = langue;
    this.translate.use(langue);
    this.translate.get("LRM").subscribe(res => {
      this.translate.use(langue);
      this.translate.use(langue);
      this.LRM = res;
    });
  }

  /*initialisation du formulaire selon les valeurs par défault à l'écran */
  ngOnInit() {
    this.langue = this.translate.currentLang;
    this.searchFormByIds = new RechercheOffresCommercialesForm(
      this.langue,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      null,
      null,
      null,
      null,
      null
    );
    this.portsFrom$ = this.getPortsObservable(this.fromSearchTerms);

    this.portsTo$ = this.getPortsObservable(this.toSearchTerms);

    //this.getAllPorts();
    this.getAllPays();
    this.getAllTypeTransports(this.langue);
    this.getAllCompagniesMaritimes();
    this.getAllManutentionnaires();
    this.fromValue = this.marseillePort;
  }

  /* Reset le formulaire sauf le champ Port */
  resetForm() {
    this.controlFormCompagniesMaritimes.reset();
    this.controlFormManutentionnaire.reset();
    this.controlFormTypeTransport.reset();
    this.controlFormPays.reset();
    this.isDirect = true;
    this.isTransbordement = true;
    this.isMarseille = true;
    this.isFos = true;
  }

  /* Récupérer les offres commerciales grâce au formulaire */
  getOffrescommercialesByForm(form: RechercheOffresCommercialesForm) {
    this.offreCommercialeService
      .getOffrescommercialesByForm(form)
      .subscribe(
        data => (this.offrescommercieles = data),
        error => (this.errorMessage = <any>error)
      );
  }

  /* Récupérer toutes les offres commerciales depuis le référentiel */
  getAllOffreCommerciales() {
    this.offreCommercialeService
      .getOffrescommercialesByForm(this.searchFormByIds)
      .subscribe(
        data => (this.offrescommercieles = data),
        error => (this.errorMessage = <any>error)
      );
  }

  /* Récupérer tous les port depuis le référentiel */
  getAllPays() {
    this.portsService.getAllPays().subscribe(
      data => {
        this.filteredPays = this.getFilterControler(data, this.controlFormPays);
      },
      error => {
        this.errorMessage = <any>error;
      }
    );
  }

  /* Récupérer tous les types de transports depuis le référentiel */
  getAllTypeTransports(langue: string) {
    this.translate.use(langue);
    this.offreCommercialeService.getAllTypesTransports(langue).subscribe(
      data => {
        this.filteredTypesTransports = this.getFilterControler(
          data,
          this.controlFormTypeTransport
        );
      },
      error => {
        this.errorMessage = <any>error;
      }
    );
  }

  /* Récupérer toutes les compagnies maritimes depuis le référentiel */
  getAllCompagniesMaritimes() {
    this.offreCommercialeService.getAllCompagniesMaritimes().subscribe(
      data => {
        this.compagnies = data;
        this.filteredCompagnies = this.getFilterControler(
          data,
          this.controlFormCompagniesMaritimes
        );
      },
      error => {
        this.errorMessage = <any>error;
      }
    );
  }

  /* Récupérer tous les manutentionnaires depuis le référentiel */
  getAllManutentionnaires() {
    this.offreCommercialeService.getAllManutentionnaires().subscribe(
      data => {
        this.filteredMautentionnaires = this.getFilterControler(
          data,
          this.controlFormManutentionnaire
        );
      },
      error => {
        this.errorMessage = <any>error;
      }
    );
  }

  /************ Gestionnaire de l'autocompletion ************/
  private _filter(
    options: IFilterAutoComplete[],
    name: string
  ): IFilterAutoComplete[] {
    const filterValue = name.toLowerCase();
    return options.filter(
      option => option.nom.toLowerCase().indexOf(filterValue) === 0
    );
  }

  getFilterControler(
    options: IFilterAutoComplete[],
    controlForm: FormControl
  ): Observable<IFilterAutoComplete[]> {
    return controlForm.valueChanges.pipe(
      startWith<string | IFilterAutoComplete>(""),
      map(value => (typeof value === "string" ? value : value.nom)),
      map(nom => (nom ? this._filter(options, nom) : options.slice()))
    );
  }

  /***********************************************************/
  /*Cette méthode retourne si un critère est saisie dans le formulaire de la recherche avancé ou pas */
  isCritereSaisie(): boolean {
    let isCritereSaisie: boolean = false;
    if (this.typeTranspValue) {
      isCritereSaisie = true;
    }
    if (this.compagnieValue) {
      isCritereSaisie = true;
    }
    if (this.manuValue) {
      isCritereSaisie = true;
    }
    if (!this.isDirect || !this.isTransbordement) {
      isCritereSaisie = true;
    }
    if (!this.isMarseille || !this.isFos) {
      isCritereSaisie = true;
    }
    return isCritereSaisie;
  }

  /*Recherche avancé des offres commerciale */
  rechercheOffrecommerciale() {
    if (!this.toValue || !this.fromValue) {
      this.searchNoResultEmitter.emit();
      return;
    }
    let from: boolean = true;
    let portToUse: Port;
    /* remplissage du formulaire de recherche par nom afin de les afficher dans le résultat de la recherche avancé */
    if (this.fromValue.nom == this.DEFAULT_PORT) {
      portToUse = this.toValue;
      from = false;
    } else {
      portToUse = this.fromValue;
      from = true;
    }
    const languEnCurent = this.translate.currentLang;
    let transbordomant;
    if (languEnCurent == "en") {
      transbordomant = "Transshipment";
    } else {
      transbordomant = this.LRM.FORM_TRANSBORDEMENT;
    }
    this.searchFormModel.manutentionnaire = this.manuValue
      ? this.manuValue.nom
      : null;
    this.searchFormModel.compagnie = this.compagnieValue
      ? this.compagnieValue.nom
      : null;
    this.searchFormModel.typeTransport = this.typeTranspValue
      ? this.typeTranspValue.nom
      : null;

    this.searchFormModel.directTransbo =
      this.isDirect && !this.isTransbordement
        ? this.LRM.FORM_DIRECT
        : !this.isDirect && this.isTransbordement
        ? this.LRM.FORM_TRANSBORDEMENT
        : this.LRM.FORM_DIRECT + " - " + transbordomant;

    this.searchFormModel.portArrivee =
      this.isMarseille && !this.isFos
        ? this.LRM.FORM_MARSEILLE
        : !this.isMarseille && this.isFos
        ? this.LRM.FORM_FOS
        : this.LRM.FORM_MARSEILLE + " - " + this.LRM.FORM_FOS;

    let isPortTouche: boolean = false;
    /* Si le port est un port selectionné depuis le référentiel sinon c'est un string saisie qui n'a pas de nom */
    for (let i = 0; i < this.portsTouches.length; i++) {
      let nomPortTouche = this.portsTouches[i].nom.toUpperCase().trim();
      let idPortTouche = this.portsTouches[i].id;
      let nomPortToUse = portToUse.nom.toUpperCase().trim();
      if (nomPortToUse == nomPortTouche && portToUse.id == idPortTouche) {
        if (portToUse.pays) {
          if (portToUse.pays == this.portsTouches[i].pays) {
            isPortTouche = true;
            portToUse = this.portsTouches[i];
            break;
          }
        } else {
          isPortTouche = true;
          portToUse = this.portsTouches[i];
        }
      }
    }

    if (!isPortTouche && !this.isCritereSaisie()) {
      this.aucunServicePourLePortRechercheEmitter.emit(true);
      if (portToUse.lat == null && portToUse.lon == null) {
        this.rechercherParGeocodage(portToUse, from);
      } else {
        this.rechercherParPortDuReferentiel(portToUse, from);
      }
    } else {
      this.aucunServicePourLePortRechercheEmitter.emit(false);
      this.startRechercheOffreCommerciale(portToUse, from, false, null);
    }
  }

  /*Lorsque le port est connu du référentiel, on vérifie si il est touché puis on uilise ses coordonnées.
  Sinon on cherche le port qui lui est plus proche*/
  rechercherParPortDuReferentiel(portToUse: Port, from: boolean) {
    var nom = portToUse.nom;
    this.portsService.getPortById(portToUse.id).subscribe(data => {
      const best = data[0];
      const location = new Location();
      location.latlng = L.latLng(best.lat, best.lon);
      let locationStart = location.latlng;
      let distancecourent;
      for (let i = 0; i < this.portsTouches.length; i++) {
        const location = new Location();
        if (this.portsTouches[i].lat) {
          location.latlng = L.latLng(
            this.portsTouches[i].lat,
            this.portsTouches[i].lon
          );
        } else {
          location.latlng = L.latLng("1", "1");
        }
        let locationEnd = location.latlng;
        if (i == 0) {
          distancecourent = Math.round(
            locationStart.distanceTo(locationEnd) / 1000.0
          );
        }
        let distance = Math.round(
          locationStart.distanceTo(locationEnd) / 1000.0
        );
        if (distance < distancecourent) {
          portToUse = this.portsTouches[i];
          distancecourent = distance;
        } else if (distance == 0) {
          portToUse = this.portsTouches[i];
          distancecourent = distance;
          break;
        }
      }
      let markerLinked: MarkerInfos = new MarkerInfos(
        1,
        location.latlng,
        nom,
        "NO",
        "NO",
        true
      );
      this.startRechercheOffreCommerciale(portToUse, from, true, markerLinked);
      this.addMarkerEmitter.emit(markerLinked);
    });
  }

  /*Lorsque le n'est pas connu du référentiel, on applique un géocodage pour récupérer sa position, puis prendre le port 
  touché le plus proche de lui*/

  rechercherParGeocodage(portToUse: Port, from: boolean) {
    var nom = portToUse.nom;
    this.geocoder
      .geocodesearchWFS(portToUse)
      .map((result: any) => {
        if (result.length === 0) {
          this.searchNoResultEmitter.emit();
          return;
        }
        return result;
      })
      .subscribe(data => {
        const best = data[0];
        const location = new Location();
        if (best.display_name && best.display_name.split(",")) {
          location.ADRESSE = best.display_name
            .split(",")[0]
            .toUpperCase()
            .trim();
        } else {
          location.ADRESSE = best.display_name.toUpperCase().trim();
        }

        location.latlng = L.latLng(best.lat, best.lon);
        let locationStart = location.latlng;
        let distancecourent;
        for (let i = 0; i < this.portsTouches.length; i++) {
          const location = new Location();
          if (this.portsTouches[i].lat) {
            location.latlng = L.latLng(
              this.portsTouches[i].lat,
              this.portsTouches[i].lon
            );
          } else {
            location.latlng = L.latLng("1", "1");
          }
          let locationEnd = location.latlng;
          if (i == 0) {
            distancecourent = Math.round(
              locationStart.distanceTo(locationEnd) / 1000.0
            );
          }
          let distance = Math.round(
            locationStart.distanceTo(locationEnd) / 1000.0
          );
          if (distance < distancecourent) {
            portToUse = this.portsTouches[i];
            distancecourent = distance;
          } else if (distance == 0) {
            portToUse = this.portsTouches[i];
            distancecourent = distance;
            break;
          }
        }
        let markerLinked: MarkerInfos = new MarkerInfos(
          1,
          location.latlng,
          nom,
          "NO",
          "NO",
          true
        );
        this.startRechercheOffreCommerciale(
          portToUse,
          from,
          true,
          markerLinked
        );
        this.addMarkerEmitter.emit(markerLinked);
      });
  }

  /*Appel du service back pour la recherche d'offres*/
  startRechercheOffreCommerciale(
    portToUse: Port,
    from: boolean,
    iscolor: boolean,
    markerLinked: MarkerInfos
  ) {
    /* remplissage des id pour le formulaire à envoyer au webService */
    this.searchFormByIds.idManutentionnaire = this.manuValue
      ? this.manuValue.id
      : null;
    this.searchFormByIds.idCompagnie = this.compagnieValue
      ? this.compagnieValue.id
      : null;
    this.searchFormByIds.idTypeTransport = this.typeTranspValue
      ? this.typeTranspValue.id
      : null;
    this.searchFormByIds.compagnie = this.compagnieValue
      ? this.compagnieValue.nom
      : null;
    this.searchFormByIds.manutentionnaire = this.manuValue
      ? this.manuValue.nom
      : null;
    this.searchFormByIds.typeTransport = this.typeTranspValue
      ? this.typeTranspValue.nom
      : null;

    this.searchFormByIds.directTransbo =
      this.isDirect && !this.isTransbordement
        ? this.FORM_DIRECT
        : !this.isDirect && this.isTransbordement
        ? this.FORM_TRANSBORDEMENT
        : this.BOTH;
    this.searchFormByIds.portArrivee =
      this.isMarseille && !this.isFos
        ? this.FORM_MARSEILLE
        : !this.isMarseille && this.isFos
        ? this.FORM_FOS
        : this.BOTH;

    /* remplissage du formulaire de recherche par nom afin de les afficher dans le résultat de la recherche avancé */
    if (from) {
      this.searchFormByIds.idPortImport = portToUse.id;
      this.searchFormModel.portImport = portToUse.nom;
      this.searchFormByIds.portImport = portToUse.nom;
      this.searchFormByIds.portExport = null;
      this.searchFormByIds.idPortExport = null;
      this.searchFormModel.portExport = null;
    } else {
      this.searchFormByIds.idPortExport = portToUse.id;
      this.searchFormModel.portExport = portToUse.nom;
      this.searchFormByIds.portExport = portToUse.nom;
      this.searchFormByIds.portImport = null;
      this.searchFormByIds.idPortImport = null;
      this.searchFormModel.portImport = null;
    }

    //this.userInformations.connexionDate = new Date();
    this.searchFormByIds.userInformations = this.userInformations;
    const langueCurent = this.translate.currentLang;
    this.searchFormByIds.codeLangue = langueCurent;
    const location = new Location();
    location.latlng = L.latLng(portToUse.lat, portToUse.lon);
    if (location.latlng != null) {
      let markerInfos: MarkerInfos = new MarkerInfos(
        portToUse.id,
        location.latlng,
        portToUse.nom,
        portToUse.flag,
        portToUse.pays,
        iscolor
      );
      markerInfos.setLinkedMarker(markerLinked);
      this.searchMapEmitter.emit(markerInfos);
    }

    console.log(this.searchFormByIds);
    this.offreCommercialeService
      .getOffrescommercialesByForm(this.searchFormByIds)
      .subscribe(
        data => {
          let isData: boolean =
            data &&
            (Object.entries(data.direct).length > 0 ||
              Object.entries(data.transbo).length > 0)
              ? true
              : false;
          if (!isData) {
            this.searchNoResultEmitter.emit();
          } else {
            this.searcheResult = data;
            this.rechercherOffrecommercialeEmitter.emit(this.searcheResult);
          }
        },
        error => {
          this.errorMessage = <any>error;
        }
      );
  }

  /** START PARTIE PAYS */

  onPaysSelected() {
    let searchForm: PortSearchForm = new PortSearchForm(
      this.paysValue.id,
      null
    );
    this.fromSearchTerms.next(searchForm);
    this.toSearchTerms.next(searchForm);

    if (this.fromValue && this.fromValue.nom == this.marseillePort.nom) {
      this.toValue = null;
    }

    if (this.toValue && this.toValue.nom == this.marseillePort.nom) {
      this.fromValue = null;
    }
  }

  onChangePaysValue(event) {
    let term: string = event.target.value;
    if (!term) {
      this.paysValue = new Pays(null, null, null);
      let searchForm: PortSearchForm = new PortSearchForm(
        this.paysValue.id,
        null
      );
      this.fromSearchTerms.next(searchForm);
      this.toSearchTerms.next(searchForm);

      if (this.fromValue && this.fromValue.nom == this.marseillePort.nom) {
        this.toValue = null;
      }

      if (this.toValue && this.toValue.nom == this.marseillePort.nom) {
        this.fromValue = null;
      }
    }
  }

  /** START PARTIE PORT **/
  displayFn(element?: IFilterAutoComplete): string | undefined {
    let valueToDisplay: string = "";
    /* J'ai recréer la constante Marseille - Fos ici car il récupère this.DEFAULT_VALUE à null (bizarre)
       Une exception sur l'affichage de Marseille - Fos selon la spécification */
    let MARSEILLE_FOS: string = "Marseille - Fos";
    if (element && element.nom) {
      if (element.nom == MARSEILLE_FOS) {
        return MARSEILLE_FOS;
      }
      valueToDisplay =
        element.nom.charAt(0).toUpperCase() +
        element.nom.substr(1).toLowerCase();
    }
    return valueToDisplay;
  }

  /** START PARTIE PORT **/
  displayFnCompagnie(element?: IFilterAutoComplete): string | undefined {
    let valueToDisplay: string = "";
    if (element && element.nom) {
      valueToDisplay = element.nom.toUpperCase();
    }
    return valueToDisplay;
  }

  /* Initialiser l'observateur qui récupère les ports selon la chaine de caractères introduite */
  getPortsObservable(searchTerms: Subject<PortSearchForm>): Observable<Port[]> {
    return searchTerms.pipe(
      // wait 30ms  each keystroke before considering the term
      // debounceTime(300),

      // ignore new term if same as previous term
      distinctUntilChanged(),

      // switch to new search observable each time the term changes
      switchMap((searchForm: PortSearchForm) =>
        this.portsService.getPortsByForm(searchForm)
      )
    );
  }

  /* Se déclenche à chaque modification de saisie dans le champs De/Vers 
  /* Elle Permet de récupèrer les ports selon la chaine de caractère introduite */
  searchPort(event, where: string): void {
    let term: string = event.target.value;
    this.EnableDisableSearchButton(null);
    if (!term || term == "") {
      return;
    }
    let idPays: number = this.paysValue ? this.paysValue.id : null;
    let searchForm: PortSearchForm = new PortSearchForm(
      idPays,
      term.toUpperCase()
    );
    switch (where) {
      case "FROM":
        this.fromValue = new Port(
          null,
          term,
          null,
          null,
          null,
          null,
          null,
          null,
          null
        );
        this.fromSearchTerms.next(searchForm);
        this.toValue = this.marseillePort;
        break;
      case "TO":
        this.toValue = new Port(
          null,
          term,
          null,
          null,
          null,
          null,
          null,
          null,
          null
        );
        this.toSearchTerms.next(searchForm);
        this.fromValue = this.marseillePort;
        break;
      default:
    }
  }

  switchPort() {
    let portTmp: Port = this.fromValue;
    this.fromValue = this.toValue;
    this.toValue = portTmp;
  }

  onPortSelected(event, where: string) {
    let port: Port = event.option.value;
    this.EnableDisableSearchButton(port.nom);
    switch (where) {
      case "FROM":
        if (port && port != this.marseillePort) {
          this.toValue = this.marseillePort;
        } else {
          this.fromValue = this.marseillePort;
        }
        break;
      case "TO":
        if (port && port != this.marseillePort) {
          this.fromValue = this.marseillePort;
        } else {
          this.toValue = this.marseillePort;
        }
        break;
      default:
    }
  }

  EnableDisableSearchButton(val: string) {
    if (val) {
      //Enable
      this.disabledSearch = false;
      this.btnPrimaryOrDefault = this.BTN_PRIMARY;
    } else {
      //Disable
      this.disabledSearch = true;
      this.btnPrimaryOrDefault = this.BTN_DEFAULT;
    }
  }

  showHidePanelAdvanceSearch() {
    this.showHidePanelEmitter.emit();
  }
  /** END PARTIE PORT **/

  setUserInformations(userInformations: UserInformaions) {
    this.userInformations = userInformations;
  }
}



// WEBPACK FOOTER //
// /Neptune/buildsJenkins/lrm_grandPublic/LRM-GP/LrGrandPublic/src/main/LRM-web/src/app/offrecommerciale/advancesearch/advancesearch.component.ts